export var IntelligentPhotoCaptureRotationAngle;
(function (IntelligentPhotoCaptureRotationAngle) {
    IntelligentPhotoCaptureRotationAngle[IntelligentPhotoCaptureRotationAngle["DEGREE_0"] = 0] = "DEGREE_0";
    IntelligentPhotoCaptureRotationAngle[IntelligentPhotoCaptureRotationAngle["DEGREE_90"] = 90] = "DEGREE_90";
    IntelligentPhotoCaptureRotationAngle[IntelligentPhotoCaptureRotationAngle["DEGREE_180"] = 180] = "DEGREE_180";
    IntelligentPhotoCaptureRotationAngle[IntelligentPhotoCaptureRotationAngle["DEGREE_270"] = 270] = "DEGREE_270";
})(IntelligentPhotoCaptureRotationAngle || (IntelligentPhotoCaptureRotationAngle = {}));
//# sourceMappingURL=IntelligentPhotoCaptureRotationAngle.js.map